module.exports = __webpack_public_path__ + "static/media/map-not-found.e8d3bd70.svg";